import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonLayoutModule, CommonUIModule } from '@sdbn/common';
import {  ServiceResponseModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { RegistrationWithCodeQRCodeCombinedComponent } from './component/registration-with-code-qrcode-combined.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    RegistrationWithCodeQRCodeCombinedComponent
  ],
  imports: [
    CommonModule,

    DictionaryModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    ServiceResponseModule,
    CommonLayoutModule,
    ZXingScannerModule,
    CommonUIModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule
]
})
export class RegistrationWithCodeQRCodeCombinedModule { }
